import React from "react";
import { FaEye, FaRegEdit, FaRegFilePdf, FaRegImage } from "react-icons/fa";

const getNoteTypeStyle = (type) => {
  switch (type) {
    case "Progress Note":
      return "text-purple-700 bg-purple-100";
    case "Initial Note":
      return "text-blue-700 bg-blue-100";
    case "Nursing Note":
      return "text-teal-700 bg-teal-100";
    default:
      return "text-gray-700 bg-gray-100";
  }
};

function ClinicalNotesTable({ notes, onView, onEdit }) {
  return (
    <div className="w-full">
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="border-b border-[#edf1f7]">
            <th className="py-4 px-2 text-[12px] font-bold text-[#111827]">
              Date & Time
            </th>
            <th className="py-4 px-2 text-[12px] font-bold text-[#111827]">
              Recorded By
            </th>
            <th className="py-4 px-2 text-[12px] font-bold text-[#111827]">
              Note Type
            </th>
            <th className="py-4 px-2 text-[12px] font-bold text-[#111827]">
              Note Content
            </th>
            <th className="py-4 px-2 text-[12px] font-bold text-[#111827] text-center">
              Attachments
            </th>
            <th className="py-4 px-2 text-[12px] font-bold text-[#111827] text-center">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {notes.map((note) => (
            <tr
              key={note.id}
              className="border-b border-[#edf1f7] last:border-0 hover:bg-gray-50 transition-colors"
            >
              <td className="py-4 px-2 text-[12px] font-semibold text-[#4b5563] whitespace-nowrap">
                {note.noteDatetime}
              </td>
              <td className="py-4 px-2 text-[12px] font-bold text-[#111827] whitespace-nowrap">
                {note.recordedByName}
              </td>
              <td className="py-4 px-2 whitespace-nowrap">
                <span
                  className={`px-3 py-1 rounded-md text-[10px] font-bold ${getNoteTypeStyle(note.type)}`}
                >
                  {note.status}
                </span>
              </td>
              <td className="py-4 px-2 text-[12px] text-[#4b5563] max-w-xs truncate">
                {note.noteText}
              </td>
              <td className="py-4 px-2 text-[12px] text-[#4b5563] text-center whitespace-nowrap">
                {note?.attachments?.length || 0}
              </td>
              <td className="py-4 px-2 text-center whitespace-nowrap">
                <div className="flex items-center justify-center gap-3">
                  <button
                    disabled={note?.attachments?.length === 0}
                    onClick={() => onView(note)}
                    className="w-7 h-7 flex items-center bg-white disabled:opacity-50 disabled:cursor-not-allowed justify-center rounded-md border border-[#edf1f7] text-[#5b5bd6] hover:bg-[#eef2ff]"
                  >
                    <FaEye className="text-[12px]" />
                  </button>
                  {/* <button
                    disabled={note.count === 0}
                    onClick={() => onEdit(note)}
                    className="w-7 h-7 flex items-center bg-white disabled:opacity-50 disabled:cursor-not-allowed justify-center rounded-md border border-[#edf1f7] text-[#5b5bd6] hover:bg-[#eef2ff]"
                  >
                    <FaRegEdit className="text-[12px]" />
                  </button> */}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ClinicalNotesTable;
